module.exports = __webpack_public_path__ + "img/ic_enabler_white.0d34d9ad.png";